"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BatchStatus = exports.PaymentProvider = void 0;
var PaymentProvider;
(function (PaymentProvider) {
    PaymentProvider["Stripe"] = "stripe";
    PaymentProvider["Coinbase"] = "coinbase";
    PaymentProvider["PayPal"] = "paypal";
    PaymentProvider["Braintree"] = "braintree";
    PaymentProvider["OpenPayment"] = "open-payment";
})(PaymentProvider || (exports.PaymentProvider = PaymentProvider = {}));
/**
 * See more at https://developer.paypal.com/docs/api/payments.payouts-batch/v1/#definition-batch_enum
 */
var BatchStatus;
(function (BatchStatus) {
    BatchStatus["Denied"] = "DENIED";
    BatchStatus["Pending"] = "PENDING";
    BatchStatus["Processing"] = "PROCESSING";
    BatchStatus["Success"] = "SUCCESS";
    BatchStatus["Canceled"] = "CANCELED";
})(BatchStatus || (exports.BatchStatus = BatchStatus = {}));
//# sourceMappingURL=types.js.map